import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import { disableSpeech, calibrateSRE } from "../sreactions";
import { ModalPrompt, ModalRadioButtonGroup, buttonTypes } from "@rosetta/react-common-ui";
import { LionTranslate } from "@rosetta/react-lion";
import { actions as audioQualityModalActions } from "./audio-quality-modals-reducer";
import LowAudioWaveIcon from "./assets/LowAudioWaveIcon";
import LoudAudioWaveIcon from "./assets/LoudAudioWaveIcon";

var TitleWrapperDiv = styled.div({
  textAlign: "center",
  fontSize: 24,
  marginTop: 36,
  marginBottom: 24
});

export var SubmitSreReport = function (_PureComponent) {
  _inherits(SubmitSreReport, _PureComponent);

  function SubmitSreReport() {
    var _temp, _this, _ret;

    _classCallCheck(this, SubmitSreReport);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.render = function () {
      var buttons = [{
        labelKey: "sre_audio_quality_wrong_many_times_report_modal_continue",
        actionFunc: function actionFunc() {
          return _this.props.hideSRESubmitReportModal({ shouldFireAfterAction: true });
        },
        buttonType: buttonTypes.primary
      }];

      return React.createElement(
        ModalPrompt,
        {
          dataQa: "SubmitSreReportModal-Submitted",
          verticalButtons: false,
          cancelAction: function cancelAction() {
            return _this.props.hideSRESubmitReportModal({ shouldFireAfterAction: true });
          },
          buttons: buttons
        },
        React.createElement(
          TitleWrapperDiv,
          null,
          React.createElement(LionTranslate, { lionkey: "sre_audio_quality_wrong_many_times_report_modal_confirm_message" })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return SubmitSreReport;
}(PureComponent);

SubmitSreReport.defaultProps = {};

SubmitSreReport.propTypes = {
  hideSRESubmitReportModal: PropTypes.func
};

var mapStateToProps = function mapStateToProps(state) {
  return {};
};

var mappedActions = {
  hideSRESubmitReportModal: audioQualityModalActions.hideSRESubmitReportModal
};

var SubmitSreReportContainer = connect(mapStateToProps, mappedActions)(SubmitSreReport);

export default SubmitSreReportContainer;